{
  "name": "cloudlink-components-chat-web",
  "version": "2.0.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "npm run build-chat && ng build",
    "build-chat": "rimraf dist/cloudlink-components-chat && ng build cloudlink-components-chat && npm run build-chat-assets",
    "build-chat-assets": "node projects/cloudlink-components-chat/copyassets.js ./projects/cloudlink-components-chat/ ./dist/cloudlink-components-chat/",
    "copy-component-to-angular-sample": "copyfiles -u 2 \"./dist/cloudlink-components-chat/**/*.\" \"../cloudlink-components-chat-angular-sample/node_modules/@mitel-internal/cloudlink-components-chat\"",
    "copy-component-to-bundle": "npm run delete-chat-in-bundle && copyfiles -u 2 \"./dist/cloudlink-components-chat/**/*.*\" \"../cloudlink-components-chat-bundle/node_modules/@mitel-internal/cloudlink-components-chat\"",
    "delete-chat-in-bundle": "rimraf ../cloudlink-components-chat-bundle/node_modules/@mitel-internal/cloudlink-components-chat/",
    "preget-stats": "ng build --configuration production --stats-json",
    "get-stats": "webpack-bundle-analyzer dist/cloudlink-components-chat-web/stats.json",
    "test": "ng test cloudlink-components-chat",
    "lint": "ng lint",
    "build-custom-element-sample": "npm run update-bundle-version && npm run build-copy-bundle-to-custom-element-sample",
    "update-angular-sample-version": "cd ../cloudlink-components-chat-angular-sample && npm install @mitel-internal/cloudlink-components-chat@\"^21.2.0\"",
    "update-bundle-version": "cd ../cloudlink-components-chat-bundle && npm install @mitel-internal/cloudlink-components-chat@\"^21.2.0\"",
    "build-bundle-dev": "rimraf ../cloudlink-components-chat-bundle/bundle && cd ../cloudlink-components-chat-bundle && npm run build-bundle",
    "build-bundle": "rimraf ../cloudlink-components-chat-bundle/bundle && cd ../cloudlink-components-chat-bundle && npm run build-bundle-prod",
    "copy-bundle-to-custom-element-sample": "rimraf ../cloudlink-components-chat-custom-element-sample/src/assets && copyfiles -u 3 \"../cloudlink-components-chat-bundle/bundle/**/*.*\" \"../cloudlink-components-chat-custom-element-sample/src\"",
    "build-copy-bundle-to-custom-element-sample": "npm run build-bundle && npm run copy-bundle-to-custom-element-sample",
    "local-build-copy-bundle-to-custom-element-sample": "npm run copy-component-to-bundle && npm run build-copy-bundle-to-custom-element-sample",
    "copy-bundle-to-dist": "rimraf dist/cloudlink-components-chat/custom-element && mkdir \"dist/cloudlink-components-chat/custom-element\" && copyfiles -u 3 \"../cloudlink-components-chat-bundle/bundle/**/*\" \"./dist/cloudlink-components-chat/custom-element\"",
    "build-only": "npm run build-chat && npm run copy-component-to-bundle && npm run build-bundle && npm run copy-bundle-to-dist",
    "prepublish-component": "npm run update-chat-version-patch && npm run build-chat && npm run copy-component-to-bundle && npm run build-bundle && npm run copy-bundle-to-dist",
    "publish-component": "npm publish ./dist/cloudlink-components-chat",
    "postpublish-component": "npm run sleep && npm run update-angular-sample-version && npm run build-custom-element-sample",
    "prepublish-pre-component": "npm run update-chat-version-prerelease && npm run build-chat && npm run copy-component-to-bundle && npm run build-bundle && npm run copy-bundle-to-dist",
    "publish-pre-component": "npm publish ./dist/cloudlink-components-chat",
    "postpublish-pre-component": "npm run sleep && npm run update-angular-sample-version && npm run build-custom-element-sample",
    "run-angular-sample": "cd ../cloudlink-components-chat-angular-sample && npm run ng serve",
    "run-custom-element-sample": "cd ../cloudlink-components-chat-custom-element-sample/src && npm run start",
    "deploy-angular-sample": "cd ../cloudlink-components-chat-angular-sample && npm run deploy",
    "export-translations": "localization-tool export",
    "import-translations": "localization-tool import",
    "sleep": "node projects/cloudlink-components-chat/sleep.js",
    "update-chat-version-major": "cd projects/cloudlink-components-chat && npm version major && node updateversion.js",
    "update-chat-version-minor": "cd projects/cloudlink-components-chat && npm version minor && node updateversion.js",
    "update-chat-version-patch": "cd projects/cloudlink-components-chat && npm version patch && node updateversion.js",
    "update-chat-version-prerelease": "cd projects/cloudlink-components-chat && npm version prerelease && node updateversion.js",
    "prepare": "cd .. && husky cloudlink-components-chat/.husky",
    "pretty-quick": "pretty-quick --staged --pattern \"**/*.{ts,html,scss}\" --ignore-path \"../.prettierignore\"",
    "prettier": "prettier --write \"**/*.{ts,html,scss}\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.24",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.24",
    "@angular/compiler": "21.2.24",
    "@angular/core": "21.2.24",
    "@angular/elements": "21.2.24",
    "@angular/forms": "21.2.24",
    "@angular/google-maps": "21.2.14",
    "@angular/localize": "21.2.24",
    "@angular/platform-browser": "21.2.24",
    "@angular/platform-browser-dynamic": "21.2.24",
    "@angular/router": "21.2.24",
    "@angular/service-worker": "21.2.24",
    "@mitel-internal/cloudlink-analytic-events": "0.0.0-alpha.31",
    "@mitel/cloudlink-sdk": "1.1.0",
    "@mitel-internal/primeng-lib": "21.2.25",
    "@microsoft/fetch-event-source": "2.0.1",
    "@ngx-translate/core": "17.0.0",
    "@popperjs/core": "2.11.8",
    "@webcomponents/custom-elements": "1.6.0",
    "@primeuix/themes": "2.0.3",
    "primeng": "21.1.1",
    "@tailwindcss/postcss": "4.1.18",
    "tailwindcss": "4.1.18",
    "tailwindcss-primeui": "0.6.1",
    "autolinker": "4.1.5",
    "blueimp-load-image": "5.16.0",
    "core-js": "3.48.0",
    "css-element-queries": "1.2.3",
    "detect-browser": "5.3.0",
    "dexie": "4.3.0",
    "dompurify": "3.4.14",
    "fs-extra": "11.3.3",
    "google-libphonenumber": "3.2.44",
    "hammerjs": "2.0.8",
    "highlight.js": "11.12.0",
    "lodash-es": "4.17.23",
    "markdown-it": "15.0.0",
    "moment": "2.31.0",
    "ngx-translate-multi-http-loader": "20.0.0",
    "os": "0.1.2",
    "paho-mqtt": "1.1.0",
    "recordrtc": "5.6.2",
    "rxjs": "7.8.2",
    "swipe-listener": "1.3.0",
    "twemoji": "14.0.2",
    "uuid": "14.0.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.24",
    "@angular/cli": "21.2.24",
    "@angular/compiler-cli": "21.2.24",
    "@angular/language-service": "21.2.24",
    "@babel/compat-data": "7.29.0",
    "@mitel-internal/localization-tool": "^1.1.3",
    "@types/dom-mediacapture-record": "1.0.22",
    "@types/google-libphonenumber": "7.4.30",
    "@types/jasmine": "5.1.5",
    "@types/jasminewd2": "2.0.13",
    "@types/jquery": "3.5.32",
    "@types/node": "22.13.2",
    "colors": "1.4.0",
    "copyfiles": "2.4.1",
    "cross-env": "10.1.0",
    "husky": "9.1.7",
    "jasmine-core": "5.6.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "ng-packagr": "21.0.1",
    "prettier": "3.6.2",
    "pretty-quick": "4.2.2",
    "replace-in-file": "8.3.0",
    "system-sleep": "1.3.8",
    "ts-node": "10.9.2",
    "tslib": "2.8.1",
    "typescript": "5.9.3",
    "uglify-es": "3.3.9",
    "uglifyjs-webpack-plugin": "2.2.0",
    "webpack-bundle-analyzer": "4.10.2"
  }
}
